import { useLocation } from 'react-router-dom';

const unAuthPages = [
  '/login',
  '/signup',
  '/password_reset',
  '/intro/addemail',
  'intro/consent',
];

export const useApp = () => {
  const { pathname } = useLocation();
  return {
    showNav: !unAuthPages.includes(pathname),
    isLogin: pathname === '/login',
    isFromAuth: unAuthPages.includes(pathname),
  };
};
